import React, { useState, useEffect, useCallback } from "react";
import * as moment from "moment";
import { FORMAT } from "web/components/utils/dateOfBirthValidation";

import { useDispatch, useSelector } from "react-redux";
import Spinner from "web/components/Spinner";
import AlertModal from "web/components/AlertModal";

import NumberInput from "web/components/form-elements/NumberInput";

import AddressEdit from "web/components/AddressEdit";
import TimePickerInput from "web/components/form-elements/TimePickerInput";
import { dateConvertToEpoch } from "web/components/utils/dateToEpoch"
import CheckboxInput from "web/components/form-elements/CheckboxInput";

import { Form, Formik } from "formik";
import { useHistory } from "react-router-dom";
import Button from "web/components/Button";
import CloseIcon from "web/assets/images/CloseIcon.png";
import { placeBid } from "redux/actions/postLoad";

import { getInitialValues, VALIDATION_SCHEMA, } from "web/components/utils/placeBidUtils";
import { Modal, ModalBody } from "reactstrap";
import "./placeBid.scss";
import { DateTimeWrapper, InputWrapper, Heading, TimeWrapper, } from "./placeBidStyle";
import { fetchLanguageContentNew } from 'redux/actions/language';

export default ({ isOpen, toggle, title, response, apiCallBack, }) => {
  let history = useHistory();
  const dispatch = useDispatch();
  let token = localStorage.getItem('token')
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");
  const toggleModal = () => setModal(!modal);

  const storedData = useSelector((state) => state.storedData.payload);
  let authId = storedData?.authId

  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()
  const [pleaceBidText, setPleaceBidText] = useState('')

  useEffect(() => {
    if (languageContentNew?.Pallets_Listing_Pages) setPageLanguageContents(languageContentNew.Pallets_Listing_Pages)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  useEffect(() => {
    if (response?.postType === "NEED") {//accountType === "Seller" || 
      setPleaceBidText(pageLanguageContents?.PlaceBidModal[1]?.Checkbox2)
    } else {
      setPleaceBidText(pageLanguageContents?.PlaceBidModal[0]?.Checkbox1)
    }
  }, [pageLanguageContents])

  const loaderVisible = useSelector(
    (state) => state.appReducer.loaderVisible
  );

  const timeFormat = (timeString) => {
    let H = +timeString.substr(0, 2);
    let h = H % 12 || 12;
    let ampm = H < 12 ? " AM" : " PM";
    timeString = h + timeString.substr(2, 3) + ampm;
    return timeString;
  };

  const handleSubmit = async (props) => {
    let setbidTimeArr = props.values.requestedStartTime.split(":");
    let pickupStartTime = props.values.requestedStartTime;
    let pickupEndTimeArr = props.values.requestedEndTime?.split(":");
    let pickupEndTime = props.values.requestedEndTime;

    if (pickupStartTime && pickupStartTime?.length) {
      let setHours = setbidTimeArr[0];
      let setMinutes = setbidTimeArr[1];
      if (setbidTimeArr[0].length === 1) {
        setHours = 0 + setbidTimeArr[0];
      }
      if (setbidTimeArr[1].length === 1) {
        setMinutes = 0 + setbidTimeArr[1];
      }
      pickupStartTime = setHours + ":" + setMinutes;
    } else {
      pickupStartTime = "08:00"
    }

    if (pickupEndTime && pickupEndTime?.length) {
      let setHours = pickupEndTimeArr[0];
      let setMinutes = pickupEndTimeArr[1];
      if (pickupEndTimeArr[0].length === 1) {
        setHours = 0 + pickupEndTimeArr[0];
      }
      if (pickupEndTimeArr[1].length === 1) {
        setMinutes = 0 + pickupEndTimeArr[1];
      }
      pickupEndTime = setHours + ":" + setMinutes;
    } else {
      pickupEndTime = "17:00";
    }

    if (pickupStartTime && pickupStartTime !== '') {
      const fromTimeValue = parseInt(pickupStartTime?.replace(":", ""));
      const toTimeValue = parseInt(pickupEndTime?.replace(":", ""));
      if (toTimeValue < fromTimeValue) {
        setModalContent(response.pickup ? "Pickup time is invalid." : "Delivery time is invalid.")
        setModalLink("");
        toggleModal();
        return
      }
    }

    let addressObj = {
      locationName: props.values.name ? props.values.name?.trim() : props.values.name,
      address1: props.values.line1 ? props.values.line1?.trim() : props.values.line1,
      address2: props.values.line2 ? props.values.line2?.trim() : props.values.line2,
      city: props.values.city ? props.values.city?.trim() : props.values.city,
      state: props.values.state,
      zipCode: props.values.zip ? props.values.zip?.trim() : props.values.zip,
    }

    Object.keys(addressObj).forEach(key => {
      if (addressObj[key] === null || addressObj[key] === '') {
        delete addressObj[key];
      }
    });

    // if(props.values.bidPrice === "00"){
    //   setModalContent("Please enter correct bid price.");
    //   setModalLink("");
    //   toggleModal();

    //   return false
    // }
    let data = {
      authId: authId || '',
      needId: response.id,
      biddingType: 'BID',
      bidPrice: props.values.bidPrice.split(",").join("").substring(1),
      requestedDate: props.values.checkOutDate,//dateConvertToEpoch(props.values.checkOutDate),
      shippingMode: response?.shippingMode || 'DELIVERY',
      appointmentStartTime: pickupStartTime,
      appointmentEndTime: pickupEndTime,
      qty: '',
      biddingAddress: addressObj || ''
    };
    Object.keys(data).forEach(key => {
      if (data[key] === null || data[key] === '') {
        delete data[key];
      }
    });

    let getResponse = await dispatch(placeBid(data, token));

    if (getResponse?.success) {
      toggle();
      setModalContent(getResponse?.data?.msg);
      if (response?.postType === "NEED") {
        setModalLink("/view-my-bids-on-pallet-needs");
      } else {
        setModalLink("/view-my-offers-on-pallet-inventory");
      }
      toggleModal();
    } else {
      if (getResponse.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(getResponse?.data?.error?.message || getResponse?.data?.message || getResponse?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  };

  const deliveryTimeAndDate = (props) => {
    return (
      <TimeWrapper>
        <TimePickerInput
          name="requestedStartTime"
          type="time"
          prePopulateState={response}
          startTime={response?.appointmentStartTime}
          showErrorMessages={true}
          props={props}
        />
        <span className="toStyle">{pageLanguageContents?.PlaceBidModal[8]?.To}</span>
        <TimePickerInput
          name="requestedEndTime"
          type="time"
          prePopulateState={response}
          endTime={response?.appointmentEndTime}
          showErrorMessages={true}
          props={props}
        />
      </TimeWrapper>
    );
  };

  const nonEditableTime = (startTime, endTime) => {
    return (
      <TimeWrapper>
        <InputWrapper>{startTime && timeFormat(startTime)}</InputWrapper>
        <span className="toStyle">{pageLanguageContents?.PlaceBidModal[8]?.To}</span>
        <InputWrapper>{endTime && timeFormat(endTime)}</InputWrapper>
      </TimeWrapper>
    );
  };
  const tConvert = (time) => {
    if (time) {
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (time.length > 1) {
        time = time.slice(1);

        time[5] = +time[0] < 12 ? " AM" : " PM";
        time[0] = +time[0] % 12 || 12;
      }
      return time.join("");
    }
  };

  let daysOfWeek = []

  const recurrenceTag = (response) => {
    let dayOfWeekVal = ''
    if (response?.orderRecurrence && response?.orderRecurrence?.pattern && response?.orderRecurrence?.pattern?.dayOfWeek) {
      if (response?.orderRecurrence?.pattern?.dayOfWeek === 'MONDAY') {
        dayOfWeekVal = 'M'
      } if (response?.orderRecurrence?.pattern?.dayOfWeek === 'TUESDAY') {
        dayOfWeekVal = ' T'
      } if (response?.orderRecurrence?.pattern?.dayOfWeek === 'WEDNESDAY') {
        dayOfWeekVal = ' W'
      } if (response?.orderRecurrence?.pattern?.dayOfWeek === 'THURSDAY') {
        dayOfWeekVal = ' Th'
      } if (response?.orderRecurrence?.pattern?.dayOfWeek === 'FRIDAY') {
        dayOfWeekVal = ' F'
      } if (response?.orderRecurrence?.pattern?.dayOfWeek === 'SATURDAY') {
        dayOfWeekVal = ' Sat'
      } if (response?.orderRecurrence?.pattern?.dayOfWeek === 'SUNDAY') {
        dayOfWeekVal = ' Sun'
      }
    }

    daysOfWeek = []

    if (response?.orderRecurrence && response?.orderRecurrence?.pattern && (response?.orderRecurrence?.pattern?.type === "WEEKLY" || response?.orderRecurrence?.pattern?.type === "RELATIVEMONTHLY" || response?.orderRecurrence?.pattern?.type === 'MONTHLY')) {
      for (let i = 0; i < response?.orderRecurrence?.pattern?.daysOfWeek.length; i++) {
        if (response?.orderRecurrence?.pattern?.daysOfWeek[i] === 'MONDAY') {
          daysOfWeek.push('M')
        } if (response?.orderRecurrence?.pattern?.daysOfWeek[i] === 'TUESDAY') {
          daysOfWeek.push(' T')
        } if (response?.orderRecurrence?.pattern?.daysOfWeek[i] === 'WEDNESDAY') {
          daysOfWeek.push(' W')
        } if (response?.orderRecurrence?.pattern?.daysOfWeek[i] === 'THURSDAY') {
          daysOfWeek.push(' Th')
        } if (response?.orderRecurrence?.pattern?.daysOfWeek[i] === 'FRIDAY') {
          daysOfWeek.push(' F')
        } if (response?.orderRecurrence?.pattern?.daysOfWeek[i] === 'SATURDAY') {
          daysOfWeek.push(' Sat')
        } if (response?.orderRecurrence?.pattern?.daysOfWeek[i] === 'SUNDAY') {
          daysOfWeek.push(' Sun')
        }
      }
    }

    if (response?.orderRecurrence && response?.orderRecurrence?.pattern) {
      return <>
        <Heading>
          Recurring Order Requirements:
        </Heading>
        <div className="flow-column">
          {response?.orderRecurrence?.pattern?.type === "DAILY" && <p>Daily,&nbsp;{response?.orderRecurrence?.range?.endAfterOccurrences ? "After " + response?.orderRecurrence?.range?.endAfterOccurrences + " Recurrences" : <>{"Starting  " + moment(response?.orderRecurrence?.range?.start).format("MM/DD/YYYY")}, {"Ending " + moment(response?.orderRecurrence?.range?.endBy).format("MM/DD/YYYY")}</>}</p>}
          {response?.orderRecurrence?.pattern?.type === "WEEKLY" && <p>Weekly,&nbsp;Every&nbsp;{daysOfWeek.join(',')},&nbsp;{response?.orderRecurrence?.range?.endAfterOccurrences ? "After " + response?.orderRecurrence?.range?.endAfterOccurrences + " Recurrences" : <>{"Starting  " + moment(response?.orderRecurrence?.range?.start).format("MM/DD/YYYY")}, {"Ending " + moment(response?.orderRecurrence?.range?.endBy).format("MM/DD/YYYY")}</>}</p>}
          {response?.orderRecurrence?.pattern?.type === "MONTHLY" && <p>Monthly,&nbsp;{daysOfWeek.length !== 0 ? <>Every&nbsp;{daysOfWeek.join(',')}</> : <>{response?.orderRecurrence?.pattern?.dayOfMonth}th</>}&nbsp;{response?.orderRecurrence?.range?.endAfterOccurrences ? "After " + response?.orderRecurrence?.range?.endAfterOccurrences + " Recurrences" : <>{"Starting  " + moment(response?.orderRecurrence?.range?.start).format("MM/DD/YYYY")}, {"Ending " + moment(response?.orderRecurrence?.range?.endBy).format("MM/DD/YYYY")}</>}</p>}
          {response?.orderRecurrence?.pattern?.type === "RELATIVEMONTHLY" && <p>Monthly,&nbsp;{response?.orderRecurrence?.pattern?.dayOfWeek && <>Every&nbsp;{dayOfWeekVal}</>}&nbsp;{response?.orderRecurrence?.range?.endAfterOccurrences ? "After " + response?.orderRecurrence?.range?.endAfterOccurrences + " Recurrences" : <>{"Starting  " + moment(response?.orderRecurrence?.range?.start).format("MM/DD/YYYY")}, {"Ending " + moment(response?.orderRecurrence?.range?.endBy).format("MM/DD/YYYY")}</>}</p>}
        </div>
      </>
    }

  }

  let addressState = false;

  if (storedData?.data?.userRole === 'BROKER' && response?.postType === "NEED" && response?.shippingMode !== 'DELIVERY') {
    addressState = true
  }
  return (
    <div className="alert-modal">
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={"static"}
        centered={true}
        className="placeBidContainer"
      >
        <div className="modal-content">
          <div className="header">
            <Button
              handleClick={() => {
                toggle(!isOpen);
              }}
            >
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            <h3>{title}</h3>
          </div>
          <ModalBody>
            <div className="placeBidBody">
              {loaderVisible && <Spinner />}
              <Formik
                initialValues={getInitialValues(response, storedData)}
                validationSchema={VALIDATION_SCHEMA(pageLanguageContents, addressState)}
                onSubmit={(values) => { }}
              >
                {(props) => {
                  const {
                    isValid,
                    dirty,
                  } = props;
                  return (
                    <>
                      <Form>
                        <div className="section">
                          <div className="row ">
                            <div className="col-md-12 col-sm-12">
                              {response.displayCostToMarket &&
                                <div className="row align-items-center">
                                  <div className="col-md-12 col-sm-12">
                                    {response?.targetPrice ? <p>Target Price : ${response?.targetPrice.toFixed(2)} (p/pal)</p> : <p>Target Price : NA</p>}
                                    {recurrenceTag(response)}
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                          <div className="row ">
                            <div className="col-md-6 col-sm-12">
                              <div className="mt-0">
                                <p>
                                  {pageLanguageContents?.PlaceBidModal[2]?.BidPrice}
                                  <span className="star">*</span>
                                  <small>{pageLanguageContents?.PlaceBidModal[3]?.PerPallet}</small>
                                </p>
                              </div>
                              <div>
                                <NumberInput
                                  name="bidPrice"
                                  prefix={"$"}
                                  thousandSeparator={true}
                                  placeholder="$0.00"
                                  maxLength={8}
                                  decimalScale={2}
                                  decimalSeparator=","
                                  fixedDecimalScale
                                  showErrorMessages={true}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row ">
                            <DateTimeWrapper className="w-100">
                              {response?.unLoadingReq !== "LIVE_UNLOAD" && response?.shippingMode !== 'PICKUP' && (
                                <>
                                  <div className="mt-0  col-md-4 col-sm-12">
                                    <p>{pageLanguageContents?.PlaceBidModal[4]?.DeliveryDate}</p>
                                    <InputWrapper>
                                      {/* {moment(new Date(response?.requestedDate * 1000)).format(FORMAT)} */}
                                      {moment(response?.requestedDate).format(FORMAT)}
                                    </InputWrapper>
                                  </div>
                                  <div className="col-md-8 col-sm-12">
                                    <div className="mt-0">
                                      <p>{pageLanguageContents?.PlaceBidModal[5]?.DeliveryTime}</p>
                                    </div>
                                    {/* {}
                                        {deliveryTimeAndDate(props)} */}
                                    {nonEditableTime(
                                      response?.appointmentStartTime ? response?.appointmentStartTime : '08:00:00',
                                      response?.appointmentEndTime ? response?.appointmentEndTime : '17:00:00'
                                    )}
                                  </div>
                                </>
                              )}
                              {response?.unLoadingReq === "LIVE_UNLOAD" && response?.shippingMode !== 'PICKUP' && (<>
                                <div className="mt-0  col-md-4 col-sm-12">
                                  <p>{pageLanguageContents?.PlaceBidModal[4]?.DeliveryDate}</p>
                                  <InputWrapper>
                                    {/* {moment(new Date(response?.requestedDate * 1000)).format(FORMAT)} */}
                                    {moment(response?.requestedDate).format(FORMAT)}
                                    {/* {moment(new Date(response?.requestedDate * 1000).toLocaleString()).format(FORMAT)} */}
                                  </InputWrapper>
                                </div>
                                <div className="col-md-8 col-sm-12">
                                  <div className="mt-0">
                                    <p>{pageLanguageContents?.PlaceBidModal[5]?.DeliveryTime}</p>
                                  </div>
                                  {nonEditableTime(
                                    response?.appointmentStartTime ? response?.appointmentStartTime : '08:00:00',
                                    response?.appointmentEndTime ? response?.appointmentEndTime : '17:00:00'
                                  )}
                                  {/* {storedData?.data?.userRole === 'BROKER'?
                                            deliveryTimeAndDate(props):<> {nonEditableTime(
                                              response?.appointmentStartTime? response?.appointmentStartTime:'08:00:00',
                                              response?.appointmentEndTime? response?.appointmentEndTime: '17:00:00'
                                            )}</> } */}

                                </div>
                              </>
                              )}
                              {response?.shippingMode === 'PICKUP' && storedData?.data?.userRole !== 'BROKER' && (
                                <>
                                  <div className="mt-0 col-md-4 col-sm-12">
                                    <div>
                                      <p>
                                        {pageLanguageContents?.PlaceBidModal[6]?.PickupDate}
                                      </p>
                                    </div>

                                    <InputWrapper>
                                      {/* {moment(new Date(response?.requestedDate * 1000)).format(FORMAT)} */}
                                      {moment(response?.requestedDate).format(FORMAT)}
                                    </InputWrapper>
                                  </div>
                                  <div className="col-md-8 col-sm-12">
                                    <div className="mt-0">
                                      <p>{pageLanguageContents?.PlaceBidModal[7]?.PickupTime}</p>
                                    </div>
                                    {nonEditableTime(
                                      response?.appointmentStartTime ? response?.appointmentStartTime : '08:00:00',
                                      response?.appointmentEndTime ? response?.appointmentEndTime : '17:00:00'
                                    )}
                                    {/* {storedData?.data?.userRole === 'BROKER'?
                                            deliveryTimeAndDate(props):<> {nonEditableTime(
                                              response?.appointmentStartTime? response?.appointmentStartTime:'08:00:00',
                                              response?.appointmentEndTime? response?.appointmentEndTime: '17:00:00'
                                            )}</> } */}

                                  </div>
                                </>
                              )}
                              {response?.shippingMode === 'PICKUP' && storedData?.data?.userRole === 'BROKER' && (
                                <>
                                  <div className="mt-0 col-md-4 col-sm-12">
                                    <div>
                                      <p>
                                        {pageLanguageContents?.PlaceBidModal[6]?.PickupDate}
                                      </p>
                                    </div>

                                    <InputWrapper>
                                      {/* {moment(new Date(response?.requestedDate * 1000)).format(FORMAT)} */}
                                      {moment(response?.requestedDate).format(FORMAT)}
                                    </InputWrapper>
                                  </div>
                                  <div className="col-md-8 col-sm-12">
                                    <div className="mt-0">
                                      <p>{pageLanguageContents?.PlaceBidModal[7]?.PickupTime}</p>
                                    </div>
                                    {nonEditableTime(
                                      response?.appointmentStartTime ? response?.appointmentStartTime : '08:00:00',
                                      response?.appointmentEndTime ? response?.appointmentEndTime : '17:00:00'
                                    )}
                                    {/* {deliveryTimeAndDate(props)} */}
                                  </div>
                                </>
                              )}
                            </DateTimeWrapper>

                          </div>
                          {response?.unLoadingReq === "LIVE_UNLOAD" && response?.shippingMode !== 'PICKUP' && response?.appointmentType === "REQUEST_DELIVERY_APPOINTMENT" && <div className="row ">
                            <div className="col-12 align-items-end d-flex">
                              <p>The Requested delivery appointment is at {tConvert(response?.appointmentStartTime)}</p>
                            </div>
                          </div>}

                          {storedData?.data?.userRole === 'BROKER' && response?.postType === "NEED" && response?.shippingMode === 'PICKUP' && <AddressEdit props={props} response={response} />}
                          {storedData?.data?.userRole === 'BROKER' && response?.postType !== "NEED" && response?.shippingMode === 'DELIVERY' && <AddressEdit props={props} response={response} />}

                          <div className="row ">
                            <div className="col-12 align-items-end d-flex">
                              <div className="field FormCheckBox">
                                <CheckboxInput
                                  name="confirmBid"
                                  label={pleaceBidText}
                                  handleSelect={() => { }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="btnSection">
                              <Button
                                type="app-green-button"
                                name="createGroup"
                                handleClick={() => {
                                  handleSubmit(props);
                                }}
                                disabled={!(isValid && dirty)}
                              >
                                {pageLanguageContents?.PlaceBidModal[9]?.Confirm}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    </>
                  );
                }}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        content={modalContent}
        link={modalLink === '/view-my-bids-on-pallet-needs' ? "" : modalLink}
        alertType={modalLink === '/view-my-bids-on-pallet-needs' ? "MyOfferPostBids" : ""}
        postType="PostLoad"
        postCallBackAlert={() => {
          let obj = {
            postType: "PostLoad",
            type: "bidsPalletNeeds",
            activePage: 'PostLoad',
            expanded: 'panel2'
          }
          dispatch({ type: 'BID_NEEDS', payload: obj })

          history.push({
            pathname: modalLink,
          })
        }}
      />
    </div>
  );
};
